var isTouchDeviceState = false;

if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
    isTouchDeviceState = true;
}

var deviceAgent = navigator.userAgent.toLowerCase();
isTouchDeviceState = (deviceAgent.match(/(iphone|ipod|ipad)/) || deviceAgent.match(/(android)/) || deviceAgent.match(/(iemobile)/) || deviceAgent.match(/iphone/i) || deviceAgent.match(/ipad/i) || deviceAgent.match(/ipod/i) || deviceAgent.match(/blackberry/i) || deviceAgent.match(/bada/i));

// Saw in Modernizr issues thread about the old Modernizr.touch check
if (
    (window.location.host == 'apps.facebook.com') || // in the facebook app it's difficult to manage media queries (cause of the sidebar) so in desktop devices with touch screen it's tricky
    (window.screen.width > 1279 && window.devicePixelRatio == 1) || // this number could be probably 1281, there are no so many mobile devices with more than 1280 and pixelRatio equal to 1 (i.e. retina displays are equal to 2...)
    (window.screen.width > 1000 && window.innerWidth < (window.screen.width * .9)) || // this checks in the end if a user is using a resized browser window which is not common on mobile devices
    (window.screen.width > 1000 && !this.browser.mobile) // this.browser.mobile is a custom check that can use for instance a common jquery plugin for browser detection
) {
    // then add a class to html
    document.querySelector('html').classList.add('force-no-touch');
}

function isTouchDevice() {
    var el = document.createElement('div');
    el.setAttribute('ontouchmove', 'return;');
    if (typeof el.ontouchmove == "function") {
        return true;
    } else {
        return false
    }
}